import React, { useState } from 'react'
import { graphql } from 'gatsby'
import _ from 'lodash'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tabs, Tab, Grid } from '@material-ui/core'
import MobileView from '../utils/MobileView'
import BrowserView from '../utils/BrowserView'
import LayoutSport from '../components/layout-sport'
import MarketingHeader from '../components/MarketingHeader'
import SectionHeader from '../components/SectionHeader'
import InplayFixtures from '../components/FixtureWidgets/InplayFixtures'
import FeaturedFixtures from '../components/FixtureWidgets/FeaturedFixtures'
import UpcomingFixtures from '../components/FixtureWidgets/UpcomingFixtures'
import TabPanels from '../components/TabPanels'

const IndexSectionTabs = styled(Tabs)`
  background: ${props => props.theme.palette.background.paper};
  @media (max-width: 768px) {
    position: sticky;
    z-index: 10;
    top: 56px;
  }
`
const IndexPage = ({ data }) => {
  // Local state
  // value is the selected sport (via tabs change)
  const [value, setIndexValue] = useState(0)
  // the fixtures
  const { edges } = data.allPostsJson
  // handleChange as per MUI docs example
  const indexHandleChange = (event, newIndexValue) => {
    setIndexValue(newIndexValue)
  }

  function a11yProps(index) {
    return {
      id: `index-tab-${index}`,
      'aria-controls': `index-tabpanel-${index}`,
    }
  }

  const RenderIndex = () => (
    <>
      <MobileView>
        <IndexSectionTabs
          value={value}
          onChange={indexHandleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          aria-label="index tabs"
          style={{ marginBottom: '8px' }}
        >
          <Tab label="In-Play" {...a11yProps(0)} style={{ width: '33%' }} />
          <Tab label="Featured" {...a11yProps(1)} style={{ width: '33%' }} />
          <Tab label="Up Next" {...a11yProps(2)} style={{ width: '33%' }} />
        </IndexSectionTabs>
        <TabPanels value={value} index={0}>
          <InplayFixtures data={edges} page="home" />
        </TabPanels>
        <TabPanels value={value} index={1}>
          <FeaturedFixtures data={edges} />
        </TabPanels>
        <TabPanels value={value} index={2}>
          <UpcomingFixtures data={edges} />
        </TabPanels>
      </MobileView>
      <BrowserView>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <InplayFixtures data={edges} page="home" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SectionHeader icon="star" title="Featured Sport" />
            <FeaturedFixtures data={edges} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SectionHeader icon="alarm" title="Up Next" />
            <UpcomingFixtures data={edges} />
          </Grid>
        </Grid>
      </BrowserView>
    </>
  )

  return (
    <LayoutSport>
      <MarketingHeader
        promoHeader="Double your winnings"
        promoCopy="Up to $50 in Bonus Bets"
        promoButton="View Markets Now"
        promoURL="/soccer"
        sport="soccer"
      />
      <RenderIndex />
    </LayoutSport>
  )
}

IndexPage.propTypes = {
  data: PropTypes.object,
}

export const indexQuery = graphql`
  query IndexQuery {
    allPostsJson {
      edges {
        node {
          id
          slug
          sport
          competition
          date
          start
          status
          marketCount
          team1title
          team2title
          gametime
          gameperiod
          gamescore
          markets {
            title
            outcomes {
              name
              odds
            }
          }
        }
      }
    }
  }
`
export default IndexPage
